import { z } from 'zod';
import { MAX_FLEET_AUTHORITY_LIMIT } from '../constants/business/fleet-portal';

/**
 * The stored shape of `fleet_default_delegated_authority` (CUR-1052): a single
 * JSON number, ex GST. Shared so the settings page cannot save a value the
 * quote evaluation then refuses — a refused value would silently fall back to
 * the platform default while the page shows the organisation's own figure.
 */
export const fleetDefaultDelegatedAuthoritySchema = z.number().finite().nonnegative().max(MAX_FLEET_AUTHORITY_LIMIT);

/** Amounts entered for client and membership authority, including CSV imports. */
export const fleetAuthorityAmountSchema = fleetDefaultDelegatedAuthoritySchema.multipleOf(0.01);

/** Parses a stored setting value; null when absent or unusable. */
export function parseFleetDefaultDelegatedAuthority(rawValue: string | null | undefined): number | null {
    if (!rawValue) {
        return null;
    }
    try {
        return fleetDefaultDelegatedAuthoritySchema.parse(JSON.parse(rawValue));
    } catch {
        return null;
    }
}
